//---------- Website right click off -----------


function directionalHover(element, options) {
  // Default options
  const opts = Object.assign({
    overlay: 'hov_overlay',
    easing: 'swing',
    speed: 500
  }, options || {});

  // Create bit flags
  const FLAG_T = 1; // top
  const FLAG_R = 2; // right
  const FLAG_B = 4; // bottom
  const FLAG_L = 8; // left

  // Create bit masks
  const tlMask = FLAG_T | FLAG_L;
  const trMask = FLAG_T | FLAG_R;
  const blMask = FLAG_B | FLAG_L;
  const brMask = FLAG_B | FLAG_R;

  function slideOverlay(overlay, direction, px, py, ew, eh, ex, ey) {
    let cornerFlags = 0;

    if (py - ey <= eh / 2) {
      cornerFlags ^= FLAG_T;
    }

    if (px - ex >= ew / 2) {
      cornerFlags ^= FLAG_R;
    }

    if (py - ey > eh / 2) {
      cornerFlags ^= FLAG_B;
    }

    if (px - ex < ew / 2) {
      cornerFlags ^= FLAG_L;
    }

    findSide(
      cornerFlags,
      overlay,
      direction,
      px - ex,
      py - ey,
      ew / 2,
      eh / 2
    );
  }

  function findSide(flags, overlay, direction, x, y, w, h) {
    if (testMask(flags, tlMask)) {
      testTopLeftToBottomRight(x, y, w, h)
        ? setOverlayPosition(overlay, direction, 0, -w * 2)
        : setOverlayPosition(overlay, direction, -h * 2, 0);
    }

    else if (testMask(flags, trMask)) {
      testBottomRightToTopLeft(x, y, w, h)
        ? setOverlayPosition(overlay, direction, -h * 2, 0)
        : setOverlayPosition(overlay, direction, 0, w * 2);
    }

    else if (testMask(flags, blMask)) {
      testBottomRightToTopLeft(x, y, w, h)
        ? setOverlayPosition(overlay, direction, 0, -w * 2)
        : setOverlayPosition(overlay, direction, h * 2, 0);
    }

    else if (testMask(flags, brMask)) {
      testTopLeftToBottomRight(x, y, w, h)
        ? setOverlayPosition(overlay, direction, h * 2, 0)
        : setOverlayPosition(overlay, direction, 0, w * 2);
    }
  }

  function testMask(flags, mask) {
    return (flags & mask) === mask;
  }

  function testTopLeftToBottomRight(x, y, w, h) {
    return (h * x - w * y) < 0;
  }

  function testBottomRightToTopLeft(x, y, w, h) {
    return (w * (y - h) + h * x - w * h) < 0;
  }

  function setOverlayPosition(overlay, direction, top, left) {
    if (direction === 'in') {
      overlay.style.top = `${top}px`;
      overlay.style.left = `${left}px`;

      requestAnimationFrame(function () {
        overlay.style.transition =
          `top ${opts.speed}ms ease, left ${opts.speed}ms ease`;

        overlay.style.top = '0px';
        overlay.style.left = '0px';
      });
    }

    else if (direction === 'out') {
      overlay.style.transition = 'none';
      overlay.style.top = '0px';
      overlay.style.left = '0px';

      requestAnimationFrame(function () {
        overlay.style.transition =
          `top ${opts.speed}ms ease, left ${opts.speed}ms ease`;

        overlay.style.top = `${top}px`;
        overlay.style.left = `${left}px`;
      });
    }
  }

  // Container styles
  element.style.position = 'relative';
  element.style.overflow = 'hidden';

  // Find overlay
  const overlay = element.querySelector('.' + opts.overlay);

  if (!overlay) {
    return;
  }

  overlay.style.position = 'absolute';
  overlay.style.top = '-100%';

  // Mouse enter
  element.addEventListener('mouseenter', function (e) {
    const rect = element.getBoundingClientRect();

    slideOverlay(
      overlay,
      'in',
      e.clientX,
      e.clientY,
      rect.width,
      rect.height,
      rect.left,
      rect.top
    );
  });

  // Mouse leave
  element.addEventListener('mouseleave', function (e) {
    const rect = element.getBoundingClientRect();

    slideOverlay(
      overlay,
      'out',
      e.clientX,
      e.clientY,
      rect.width,
      rect.height,
      rect.left,
      rect.top
    );
  });
}


// Initialize directional hover

  document.querySelectorAll('.hov_effect').forEach(function (element) {
    directionalHover(element);
  });



// ========================================
// Disable Right Click
// ========================================

document.addEventListener('contextmenu', function (event) {
  event.preventDefault();
});


// ========================================
// Disable Keyboard Shortcuts
// ========================================

document.addEventListener('keydown', function (e) {

  // F12
  if (e.key === 'F12') {
    e.preventDefault();
    return false;
  }

  // Ctrl + Shift + I
  if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'i') {
    e.preventDefault();
    return false;
  }

  // Ctrl + Shift + C
  if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'c') {
    e.preventDefault();
    return false;
  }

  // Ctrl + Shift + J
  if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'j') {
    e.preventDefault();
    return false;
  }

  // Ctrl + U
  if (e.ctrlKey && e.key.toLowerCase() === 'u') {
    e.preventDefault();
    return false;
  }
});


// ========================================
// Disable Copy / Cut
// ========================================

document.addEventListener('copy', function (e) {
  e.preventDefault();
});

document.addEventListener('cut', function (e) {
  e.preventDefault();
});











